import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu';
import Divider from 'components/Divider';
import styles from './Rtiles.scss';// to import local scss fle

class Rtiles extends Component {
  static propTypes = {
    item: PropTypes.shape(),
    updateConversation: PropTypes.func,
    profile: PropTypes.func.isRequired,
    attributes: PropTypes.shape,
  };
  static defaultProps = {
    item: {},
    updateConversation: () => {},
    attributes: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      requestCreatedBy: 'SA', // in  the my request tab it should be COACH
    };
    this.addQuestionaire = this.addQuestionaire.bind(this);
    this.inviteToCamp = this.inviteToCamp.bind(this);
    this.needMoreFilms = this.needMoreFilms.bind(this);
    this.sendContactInfo = this.sendContactInfo.bind(this);
    this.addToWatchList = this.addToWatchList.bind(this);
    this.ignoredList = this.ignoredList.bind(this);
    this.getStyles = this.getStyles.bind(this);
  }
  /* eslint-disable */
  getStyles(value) {
    let returnValue = 'interestedButton';
    if (value === 'FILL QUESTIONAIRE') {
      returnValue = 'greenButton';
    }
    if (value === 'INVITE TO CAMP') {
      returnValue = 'inviteToCampButton';
    }
    if (value === 'NEED MORE FILMS') {
      returnValue = 'needMoreFilmsButton';
    }
    if (value === 'ADDED TO WATCHLIST') {
      returnValue = 'addedToWatchListButton';
    }
    if (value === 'IGNORED') {
      returnValue = 'ignoredButton';
    }
    if (value === 'SEND CONTACT INFO') {
      returnValue = 'sendContactInfoButton';
    }
    return returnValue;
  }
/* eslint-enable */

  addQuestionaire(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'FILL QUESTIONAIRE', // let backend know if you change something here
      link: this.props.profile.get('question_link'),
      sa_email: email,
      sa_name: name,
      created_by: this.state.requestCreatedBy,
      coach_email: this.props.attributes.get('username'),
    };
    this.props.updateConversation(conversation);
  }

  inviteToCamp(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'INVITE TO CAMP',
      created_by: this.state.requestCreatedBy,
      sa_email: email,
      sa_name: name,
      coach_email: this.props.attributes.get('username'),
    };
    this.props.updateConversation(conversation);
  }

  needMoreFilms(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'NEED MORE FILMS',
      sa_email: email,
      created_by: this.state.requestCreatedBy,
      sa_name: name,
      coach_email: this.props.attributes.get('username'),
    };
    this.props.updateConversation(conversation);
  }
  addToWatchList(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'ADDED TO WATCHLIST',
      created_by: this.state.requestCreatedBy,
      sa_email: email,
      sa_name: name,
      coach_email: this.props.attributes.get('username'),
    };
    this.props.updateConversation(conversation);
  }
  ignoredList(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'IGNORED',
      created_by: this.state.requestCreatedBy,
      sa_email: email,
      sa_name: name,
      coach_email: this.props.attributes.get('username'),
    };
    this.props.updateConversation(conversation);
  }
  sendContactInfo(requestId, email, name) {
    const conversation = {
      id: requestId,
      action: 'SEND CONTACT INFO',
      created_by: this.state.requestCreatedBy,
      sa_email: email,
      sa_name: name,
      coach_email: this.props.attributes.get('username'),
    };
    this.props.updateConversation(conversation);
  }


  render() {
    const { item } = this.props;
    let arr = [];
    if (item.get('sa_preference') !== undefined) {
      const preference = item.get('sa_preference');
      arr = preference.toIndexedSeq().toArray();
    }
    const convo = item.get('conversation');
    let athleteHaveProfileImage = false;

    if (item.get('sa_image') !== undefined) {
      athleteHaveProfileImage = true;
    }
        /* const requirements = item.get('requirements'); */
    return (
      <div className={styles.container}>
        <div className={styles.tile}>
          <Link to={`/athlete/${item.get('from_profile_id')}`}>
            <div>
              <img
                className={styles.colgeIcon}
                src={athleteHaveProfileImage === true ? //eslint-disable-line
                       `https://s3.amazonaws.com/myrbimages/${item.get('sa_image')}` : //eslint-disable-line
                       'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png'}
                alt="athlete-icon"
              />
              <div className={styles.collegeName}>{item.get('sa_name')}</div>
              {/*eslint-disable*/}
              <div className={styles.sportName}>
                {arr.map((position, i) => (
                  <span>
                    {position}
                    {i < arr.length -1 ? ', ' : ''}
                  </span>
                  ))}
              </div>
              <div className={styles.userNameIcon}>
                <span >
                  <div className={styles.schoolName}>
                    {item.get('sa_school')}
                  </div>
                  <div className={styles.cityName}>
                    {item.get('sa_city')}, {item.get('sa_state')}
                  </div>
                  {item.get('year_of_graduation') &&
                    <div className={styles.cityName}>
                      Year of graduation: {item.get('year_of_graduation')}
                    </div>
                  }
                </span>
              </div>
            </div>
          </Link>
          <div className={cn(this.getStyles(convo.get(convo.size - 1).get('action')))}>
            <span>{convo.get(convo.size - 1).get('action')}</span>
            <span className={styles.dotIcons}>
              <IconMenu icon="..." position="topRight" >
                <MenuItem>
                  <button onClick={() => this.addQuestionaire(item.get('id'), item.get('sa_email'), item.get('sa_name'))}>Send My Recruiting Questionaire</button><br />
                </MenuItem>
                <Divider />
                <MenuItem>
                  <button onClick={() => this.inviteToCamp(item.get('id'), item.get('sa_email'), item.get('sa_name'))}>Invite To My Camp</button><br />
                </MenuItem>
                <Divider />
                <MenuItem>
                  <button onClick={() => this.needMoreFilms(item.get('id'), item.get('sa_email'), item.get('sa_name'))}>Please Send More Film</button><br />
                </MenuItem>
                <Divider />
                <MenuItem>
                  <button onClick={() => this.sendContactInfo(item.get('id'), item.get('sa_email'), item.get('sa_name'))}>Please Send Your Contact Information</button><br />
                </MenuItem>
                <Divider />
                <MenuItem>
                  <button onClick={() => this.addToWatchList(item.get('id'), item.get('sa_email'), item.get('sa_name'))}>Add To My Watchlist</button><br />
                </MenuItem>
                <Divider />
                <MenuItem>
                  <button onClick={() => this.ignoredList(item.get('id'), item.get('sa_email'), item.get('sa_name'))}>I&apos;m Not Interested</button><br />
                </MenuItem>
              </IconMenu>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Rtiles;



// WEBPACK FOOTER //
// ./src/components/Rtiles/Rtiles.js